import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import iconMixin from 'styles/utils/iconMixin';

const Span = styled.span`
  ${iconMixin('.925rem')};
  padding-left: 0.3125rem;
  color: ${props => props.theme.colors.notificationWarning};
  vertical-align: middle;
  line-height: inherit;
`;

const ValidationHintIcon = ({ hint }) => {
  if (!hint) {
    return null;
  }
  return <Span>info_outline</Span>;
};
ValidationHintIcon.propTypes = {
  hint: PropTypes.string,
};
ValidationHintIcon.defaultProps = {
  hint: '',
};
export default ValidationHintIcon;
